import React, { useEffect } from 'react'
import { useTeloRouter } from './teloRouter'
import { getExamByUpriseIdApi, getPatientByUpriseIdApi } from '../apiCalls'
import LoadingPage from '../pages/LoadingPage'
import {
	selectIsDoctor,
	selectIsLocalTechnician,
} from '../features/users/selectors'
import { useTeloDispatch, useTeloSelector } from '../store'
import notificationsActions from '../features/notifications/actions'
import { useTranslation } from 'react-i18next'

const DataFetchRedirect: React.FC = () => {
	const { navigate, readRouteParams, getLocation } = useTeloRouter()
	const dispatch = useTeloDispatch()
	const location = getLocation()
	const currentPath = location.pathname
	const isCurrentPage = (page: string) => currentPath.includes(page)
	const { t } = useTranslation()
	const isDoctor = useTeloSelector(selectIsDoctor)
	const isTechnician = useTeloSelector(selectIsLocalTechnician)

	const redirectPatientId = isCurrentPage('/redirect/exam-history/')
	const redirectExamId = isCurrentPage('/redirect/exam/')

	const { patientUpriseId, appointmentUpriseId } = readRouteParams(
		{
			name: 'patientUpriseId',
			required: false,
		},
		{
			name: 'appointmentUpriseId',
			required: false,
		},
	)

	const storeId = window.localStorage.getItem('tel-store-id') || ''

	useEffect(() => {
		const fetchAndRedirect = async () => {
			try {
				let targetIdResponse
				switch (true) {
					case redirectPatientId && !!patientUpriseId:
						targetIdResponse = await getPatientByUpriseIdApi(
							patientUpriseId || '',
						)

						if (targetIdResponse?._id) {
							navigate(
								`/store/${storeId}/patient-history/${targetIdResponse?._id}?historyTab=1`,
							)
						} else {
							navigate('/')
						}
						break

					case redirectExamId && !!appointmentUpriseId:
						targetIdResponse = await getExamByUpriseIdApi(
							appointmentUpriseId || '',
						)
						if (targetIdResponse?._id && isDoctor) {
							navigate(`/doctor/exam/${targetIdResponse?._id}`)
						} else if (
							targetIdResponse?._id &&
							targetIdResponse?.internalPatient &&
							isTechnician
						) {
							navigate(
								`/store/${storeId}/patients/${targetIdResponse?.internalPatient}/exams/${targetIdResponse?._id}/0`,
							)
						} else if (!targetIdResponse?._id) {
							navigate('/')
						}
						break
					default:
						console.error('No valid redirect condition met.')
						// Handle the case where neither condition is met
						break
				}
			} catch (error: any) {
				console.error('Error occurred during redirect:', error)
			}
		}

		fetchAndRedirect()
	}, [
		patientUpriseId,
		appointmentUpriseId,
		redirectPatientId,
		redirectExamId,
		storeId,
		isDoctor,
		isTechnician,
		navigate,
		dispatch,
		t,
	])

	return <LoadingPage />
}

export default DataFetchRedirect
